import React from 'react';
import InfoBlock from '../Shared/InfoBlock';

const isEmpty = (val) => !val || val.trim() === '';

const formatZip = (zip) => {
    if (!zip) return '';
    const cleaned = zip.toString().replace(/\D/g, ''); // remove non-digits
    return cleaned.length > 5
        ? `${cleaned.slice(0, 5)}-${cleaned.slice(5, 9)}`
        : cleaned;
};

const PersonCard = ({ title, person }) => {
    if (!person) return null;

    const hasAddress = person.address1 || person.address2 || person.city || person.state || person.zip;

    const displayAddress = (
        <>
            {person.address1 && <>{person.address1}<br /></>}
            {person.address2 && <>{person.address2}<br /></>}
            {(person.city || person.state || person.zip) && (
                <>
                    {[person.city, person.state].filter(Boolean).join(', ')} {formatZip(person.zip)}
                </>
            )}
        </>
    );

    return (
        <div className="personCard">
            <div className="personCardHeader">{title}</div>
            <div className="personCardBody">
                <InfoBlock label="Name:" value={person.displayName || 'N/A'} />
                <InfoBlock label="DOB:" value={person.birthDate || 'N/A'} />
                <InfoBlock label="Phone:" value={person.phone || 'N/A'} />
                <InfoBlock label="Email:" value={person.email || 'N/A'} />
                {hasAddress && <InfoBlock label="Address:" value={displayAddress} />}
            </div>
        </div>
    );
};

export default PersonCard;
